"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import "../styles/Ranking.css"

const Ranking = () => {
  const [circuitos, setCircuitos] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    const fetchCircuitos = async () => {
      try {
        const res = await axios.get("https://api.ticketdovaqueiro.com/api/circuitos")
        setCircuitos(res.data)
      } catch (error) {
        console.error("Erro ao carregar circuitos:", error.message)
      }
    }

    fetchCircuitos()
  }, [])

  return (
    <div className="fop-ranking-page">
      <div className="fop-ranking-container">
        <div className="fop-ranking-header">
          <div className="fop-ranking-title-wrapper">
            <svg className="fop-ranking-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 6V2M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM17 4L19 2M7 4L5 2M12 18V22M17 20L19 22M7 20L5 22"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <h1 className="fop-ranking-title">Ranking dos Circuitos</h1>
          </div>
          <p className="fop-ranking-subtitle">Acompanhe os melhores competidores e circuitos de vaquejada</p>
        </div>

        <div className="fop-ranking-grid">
          {circuitos.map((circuito) => (
            <div className="fop-ranking-card" key={circuito._id}>
              <div className="fop-ranking-card-badge">
                <svg
                  className="fop-ranking-badge-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 8.5V12.5L14 14.5M19 12.5C19 16.6421 15.6421 20 11.5 20C7.35786 20 4 16.6421 4 12.5C4 8.35786 7.35786 5 11.5 5C15.6421 5 19 8.35786 19 12.5Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div className="fop-ranking-card-image-container">
                <img
                  src={`https://api.ticketdovaqueiro.com/uploads/${circuito.imagem}`}
                  alt={circuito.nome}
                  className="fop-ranking-card-img"
                />
              </div>

              <div className="fop-ranking-card-content">
                <h3 className="fop-ranking-card-title">{circuito.nome}</h3>

                <button onClick={() => navigate(`/ranking/${circuito._id}`)} className="fop-ranking-card-btn">
                  Ver Ranking
                  <svg
                    className="fop-ranking-btn-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 18L15 12L9 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Ranking
